import React, { useEffect } from 'react';
import { ModalHeader, ModalBody, Typography, Button, LoadingButton, ModalFooter, } from '@one-thd/sui-atomic-components';
import { setBulkAddEventAnalytics } from '../../../../utils/add-manage-user-analytics';
import { setOverlayEvent } from '../../../../utils/analytics';
export var CancelImport = function (_a) {
    var hideModal = _a.hideModal, onConfirmCancel = _a.onConfirmCancel;
    useEffect(function () {
        setOverlayEvent('cancel entire user import');
    }, []);
    var handleOnCloseModal = function () {
        setBulkAddEventAnalytics('validation: cancel user import: no button');
        hideModal();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalHeader, { onClose: handleOnCloseModal }, "Cancel Entire User Import"),
        React.createElement(ModalBody, null,
            React.createElement(Typography, { variant: "body-base", weight: "bold" }, "Are you sure you want to cancel the entire user import?"),
            "\u00A0",
            React.createElement(Typography, { variant: "body-base" }, "This action will cancel both valid and invalid user data. No users will be added to your account.")),
        React.createElement(ModalFooter, null,
            React.createElement("div", { className: "sui-flex sui-justify-end sui-gap-4 sm:sui-gap-4 sui-flex-col-reverse sui-w-full sm:sui-flex-row" },
                React.createElement(Button, { variant: "secondary", onClick: handleOnCloseModal }, "No"),
                React.createElement(LoadingButton, { variant: "primary", onClick: function () {
                        setBulkAddEventAnalytics('validation: cancel user import: yes button');
                        onConfirmCancel();
                    } }, "Yes, Cancel Import")))));
};
